import React from "react";
import { Icon, IconProps } from "./Icon"; // Import the generic Icon component

export const ArrowForward = (props: IconProps) => {
  return (
    <Icon
      classes={props.classes}
      height="24px"
      width="24px"
      viewBox="0 0 24 24"
      dataTestId="icon-arrow-forward"
    >
      <path d="M4.2,12c0-0.6,0.4-1,1-1h11.2l-4.9-4.9c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l6.6,6.6c0.4,0.4,0.4,1,0,1.4l-6.6,6.6c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4l4.9-4.9H5.2C4.7,13,4.2,12.6,4.2,12z" />
    </Icon>
  );
};
